// import * as types from '../constants/actionTypes';
import { resourceApi } from '../utils/fetchUtil';


// Logs the user out
// export function identityError(message) {

//   return {
//     type: IDENTITY_ERROR,
//     isFetching: false,
//     message
//   }
// }



// function logUserEntry(mpi) {

//     return (dispatch, getState) => {
      
//         resourceApi(`log/login/${mpi}`, {}, dispatch, false)
//           .then(function (response) {
//               console.log(response);
//           })
//           .catch(function (error) {
//               console.log(error);
//           });
//     }
// }

export function logUserSearch(sctp, term) {

    return (dispatch, getState) => {
      
        const { thisApp } = getState();
      
         let config = {
            method: 'post',
            //url: `log/usersearch/${thisApp.auth.member.ClientUserID}/${sctp}`
            url: `log/search/`,
            data:{
                ClientUserID: thisApp.auth.member.ClientUserID,
                SearchTerm: term,
                ShoppableCPTCodeID: sctp
            }
        };
        
        resourceApi(config, dispatch, false)
          .then(function (response) {
              console.log(response);
          })
          .catch(function (error) {
              console.log(error);
          });
    }
}


// export function logSctpClick(sctp) {

//     return (dispatch, getState) => {
      
//         const { thisApp } = getState();
      
//         resourceApi(`log/usersearch/${thisApp.auth.member.ClientUserID}`, {}, dispatch)
//           .then(function (response) {
//               console.log(response);
//           })
//           .catch(function (error) {
//               console.log(error);
//           });
//     }
// }




export function logDirectionsClick(providerId, action) {

    return (dispatch) => {
      
        let config = {
            method: 'get',
            url: `log/directions/${providerId}/${action}`
        };

        resourceApi(config, dispatch, false)
          .then(function (response) {
              console.log(response);
          })
          .catch(function (error) {
              console.log(error);
          });
    }
}

export function logDocDetailsClick(providerId) {

    // return (dispatch) => {
      
    //     let config = {
    //         method: 'get',
    //         url: `log/docdetails/${providerId}`
    //     };

    //     resourceApi(config, dispatch, false)
    //       .then(function (response) {
    //           console.log(response);
    //       })
    //       .catch(function (error) {
    //           console.log(error);
    //       });
    // }
}

export function logQualityClick(providerId) {

// manual searches
    return  (dispatch, getState) => {
      
        // const { thisApp } = getState();

        // let config = {
        //     method: 'get',
        //     url: `log/docdetails/${providerId}`
        // };

        // resourceApi(config, dispatch, false)
        //   .then(function (response) {
        //       console.log(response);
        //   })
        //   .catch(function (error) {
        //       console.log(error);
        //   });
    }
}


export function logProviderView(log) {

    return (dispatch) => {
      
        let config = {
            method: 'post',
            url: `log/provider/view`,
            data: log
        };

        resourceApi(config)
          .then(function (response) {
              console.log(response);
          })
          .catch(function (error) {
              console.log(error);
          });
    }
}


export function logSsoClick(ssoProviderId) {

    let config = {
        method: 'get',
        url: `log/sso/${ssoProviderId}`
    };

    resourceApi(config)
      .then(function (response) {
          console.log(response);
      })
      .catch(function (error) {
          console.log(error);
      });
}


export function logActivityTracker(actionType) {

    let config = {
        method: 'get',
        url: `log/activityTracker/${actionType}`
    };

    resourceApi(config)
      .then(function (response) {
          console.log(response);
      })
      .catch(function (error) {
          console.log(error);
      });
}




// WEBPACK FOOTER //
// ./src/actions/logActions.js